import AuthServiceRepository from "../../ports/authServiceRepository";

export type logoutUsecase = () => Promise<boolean>;

export const buildLogout = (dependencies: {
  authServiceRepo: AuthServiceRepository;
}): logoutUsecase => {
  const { authServiceRepo } = dependencies;

  const logout: logoutUsecase = async () => authServiceRepo.logout();

  return logout;
};
